import { axiosInstance } from "@/config/axiosInstance";

//  ****** GET ALL PERFORMANCE REPORTS FOR EMPLOYEE ******
export const fetchAllPerformanceReportsForEmployeeByAdmin =
  (adminKey: string) =>
  (data: { year: number; employee: string; month?: string }) =>
    axiosInstance
      .post<{
        success: boolean;
        remaining: number;
        performanceReports: {
          month: string;
          year: number;
          remainingPoints: number;
          totalPoints: number;
          _id: string;
          misconducts: {
            reason: string;
            dateAdded: Date;
            misconductOn: Date;
            misconductFor: string;
            misconductingInvolvingOthers: boolean;
            penalties: string[];
          }[];
        }[];
      }>(`/performance/report/admin/all-month-employee`, data, {
        headers: {
          authorization: `Bearer ${adminKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);
